module.exports = __webpack_public_path__ + "img/bind-wx.d9ca6af6.png";